import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { pushVirtualPageView } from "../utils/dataLayer";

const GtmPageView = () => {
  const location = useLocation();

  useEffect(() => {
    pushVirtualPageView({
      pagePath: `${location.pathname}${location.search}`,
      pageLocation: window.location.href,
      pageTitle: document.title,
    });
  }, [location.pathname, location.search]);

  return null;
};

export default GtmPageView;
